<script setup lang="ts">
  import { MpCard, MpText, useMpScreen } from '@borg/ui';

  const props = defineProps<{
    hideAverageSalary?: boolean;
  }>();

  const job = jobRepository.use();
  const { isMobile } = useMpScreen();

  const paycheckMap: Record<number, number> = {
    1: 1171.80,
    2: 1391.00,
    3: 1322.00,
    4: 907.37,
    5: 1154.92,
    6: 1395.41,
    7: 1292.58,
    8: 1315.19,
    9: 1424.31,
    10: 1259.45,
    11: 1690.26,
    12: 1369.57,
    13: 1317.94,
    14: 1251.88,
    15: 929.38,
    16: 1186.58,
    17: 1409.60,
    18: 1105.61,
    19: 1205.83,
    20: 1246.67,
    21: 1242.18,
    22: 1090.98,
    23: 968.54,
    24: 1370.83,
    25: 1170.65,
    26: 1353.84,
    27: 2686.74,
    28: 1382.71,
  };

  const salary = props.hideAverageSalary
    ? false
    : computed(() =>
        job.value
          ? job.value.rootPosition?.id
            ? paycheckMap[job.value.rootPosition.id]
            : false
          : false,
      );
</script>

<template>
  <MpCard
    shadow
    border
    class="container no-print"
    :p="isMobile ? 'md' : 'lg'"
  >
    <LinksLocale
      to="https://www.mojaplaca.hr/"
      target="_blank"
      class="container__logo"
    >
      <Illustration
        image="my-paycheck"
        height="32"
      />
    </LinksLocale>
    <MpText
      v-if="salary"
      as="h6"
      regular
    >
      {{ $t('MY_PAYCHECK.SALARY.1') }}
      <MpText type="h6">
        {{ job.rootPosition?.name }}
      </MpText>
      {{ $t('MY_PAYCHECK.SALARY.2') }}
      <MpText type="h6">
        {{ `${salary} EUR*` }}
      </MpText>
    </MpText>
    <MpText no-margin>
      {{ $t('MY_PAYCHECK.DESCRIPTION') }}
    </MpText>
    <a
      href="https://www.mojaplaca.hr/istrazivanje-placa-wizard"
      target="_blank"
      class="container__button"
    >
      {{ $t('MY_PAYCHECK.BUTTON.TITLE') }}
    </a>

    <MpText
      v-if="salary"
      class="container__description"
    >
      {{ $t('MY_PAYCHECK.SALARY.DESCRIPTION') }}
    </MpText>
  </MpCard>
</template>

<style scoped lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;
    color: var(--mp-color-text-05);

    h6 {
      font-size: 16px;
    }

    &__logo {
      margin-bottom: var(--mp-space-50);
    }

    &__button {
      display: flex;
      align-items: center;
      height: 32px;
      padding: var(--mp-space-30) var(--mp-space-60);
      margin-top: var(--mp-space-60);
      border-radius: 5px;
      background-color: #85c21d;
      color: white;
      font-size: 16px;
      text-decoration: none;
    }

    &__description {
      margin-top: var(--mp-space-60);
      margin-bottom: 0;
      font-size: 14px;
    }
  }
</style>
